import {
  AccessList,
  Installation,
  EquipmentDocumentResponse,
  SubscriptionPlan,
  ViCarePlan,
  InstallationMonetizationFeatures,
  GetResponse,
  AccountByCompany,
} from '@vi-iot/client';

import { Status, StatusValue } from '../app.state.models';
import { DashboardTypes, GenericStoreStatus, PanelsOrderState } from './installation-details.model';

export interface InstallationDetailsState {
  availablePaidFeatures: string[];
  panelsOrder: PanelsOrderState;
  serviceInstruction: StatusValue<EquipmentDocumentResponse[]>;
  maintenanceChecklist: MaintenanceChecklistState;
  subscriptionPlan: SubscriptionPlan;
  subscriptionPlanLoading: boolean;
  vicarePlans?: StatusValue<ViCarePlan[]>;
  monetizationFeatures?: StatusValue<GetResponse<InstallationMonetizationFeatures>>;
  accessList?: AccessList;
  installation?: StatusValue<Installation>;
  updateBuildingInfoStatus: Status;
  isPermamentInspectionFeatureSupported: boolean;
  loading: boolean;
  loaded: boolean;
  error: any;
  deregisterGateway: {
    pending: boolean;
    success: boolean;
    error: boolean;
  };
  selectedDashboardTypeHelper: DashboardTypes;
  accountsByCompany?: AccountByCompany;
}

interface MaintenanceChecklistState extends GenericStoreStatus {
  value: EquipmentDocumentResponse[];
}

export enum HemsAdvancedAnalysisStatus {
  DisplayAnalysis,
  HemsNotActivated,
}
